import { render, staticRenderFns } from "./about_Us.vue?vue&type=template&id=0082142e&scoped=true"
import script from "./about_Us.vue?vue&type=script&lang=js"
export * from "./about_Us.vue?vue&type=script&lang=js"
import style0 from "./about_Us.vue?vue&type=style&index=0&id=0082142e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082142e",
  null
  
)

export default component.exports